import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserLoggedInState {
  isUserLoggedIn: boolean;
}

interface UserLoggedInPayload {
  isUserLoggedIn: boolean;
}

export const initialState: UserLoggedInState = {
  isUserLoggedIn: false
};

const isUserLoggedInSlice = createSlice({
  name: 'UserLoggedIn',
  initialState,
  reducers: {
    setIsUserLoggedIn(state, action: PayloadAction<UserLoggedInPayload>) {
      state.isUserLoggedIn = action.payload.isUserLoggedIn;
    }
  }
});

export const {
  setIsUserLoggedIn
} = isUserLoggedInSlice.actions;

export default isUserLoggedInSlice.reducer;
